module.exports = __webpack_public_path__ + "img/users.df8621a4.svg";